import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";

const STATUS_KEYS = {
  [APITypes.StayStatusType.Inquiry]: "Stay_status_inquiry",
  [APITypes.StayStatusType.Pending]: "Stay_status_pending",
  [APITypes.StayStatusType.Confirmed]: "Stay_status_confirmed",
  [APITypes.StayStatusType.CheckedIn]: "Stay_status_checked_in",
  [APITypes.StayStatusType.Completed]: "Stay_status_completed",
  [APITypes.StayStatusType.Cancelled]: "Stay_status_cancelled",
  [APITypes.StayStatusType.Rejected]: "Stay_status_rejected",
} as const;

const STATUS_COLOR: Record<APITypes.StayStatusType, string> = {
  [APITypes.StayStatusType.Inquiry]: "default",
  [APITypes.StayStatusType.Pending]: "orange",
  [APITypes.StayStatusType.Confirmed]: "cyan",
  [APITypes.StayStatusType.CheckedIn]: "green",
  [APITypes.StayStatusType.Completed]: "default",
  [APITypes.StayStatusType.Cancelled]: "red",
  [APITypes.StayStatusType.Rejected]: "red",
};

export function StayStatusTag({ status }: { status: APITypes.StayStatusType }) {
  const { t } = useTranslation();
  const labelKey = STATUS_KEYS[status];
  return (
    <Tag color={STATUS_COLOR[status] ?? "default"}>
      {labelKey ? t(labelKey) : status}
    </Tag>
  );
}
